// Footer Script mainly to get proper padding

(function($) {

    let arriveOptions = {
        onceOnly: true, // ensure that registered callbacks fire only once
        existing: true, // ensure that the registered callback is fired for the elements that already exist in the DOM and match the selector
    };

    let footer = '#theme-footer';
    let content = '#content';

    function footerContentPadding() {
        if( $(footer).length ) {
            let footerHeight = $(footer).outerHeight();
            $(content).css('padding-bottom', `${footerHeight}px`);
        }
    }
    
    footerContentPadding();

    $(document).arrive(footer, arriveOptions, function() {
        footerContentPadding();
    });
    
    //# - On Resize
    $(window).on('resize', function() {
        footerContentPadding();
    });

})(jQuery);